<template lang="pug">
  .login-body
    .login
      img.logo(:src="logo" width="88px" height="88px" @click="goHome")
      p.system-name 数字经济时代的云智能操作系统
      router-view
      el-button.primary-button.fullwidth-button.confirmBtn(
        :class="isDisableButton"
        :type="confirmButtonType"
        :disabled="disableLogin"
        @click="confirmBtnClick") {{ confirmBtnText }}
    
    footer.footer
      router-link.text-button(:to="{name: 'GuestForm'}") 联系我们
      p.footnote-font COPYRIGHT © 2019-2020 粤ICP备19082412号

</template>

<script>
  import LoginForm from "@/views/Login/LoginForm/index";
  import {mapActions, mapMutations, mapState} from "vuex";
  import GuestForm from "@/views/Login/GuestForm/index";
  import {contactUs, login} from "@/utils/requestFn";
  import logo from "@/assets/images/Logo.png"
  import Bus from "@/bus/index"

  export default {
    name: "login",
    components: {GuestForm, LoginForm},
    data() {
      return {
        logo,
        disableLogin: false,
        countDown: 0,
        confirmBtnClickNum: 0,
        confirm: null,
      };
    },
    watch: {
      disableLogin(val) {
        if (val) {
          this.setCannotLogin();
        }
      },
      $route: {
        immediate: true,
        handler(to, from) {
          if (to.name === 'LoginForm') {
            this.confirm = this.login;
          } else if (to.name === 'GuestForm') {
            this.confirm = this.contactUs;
          }
        }
      }
    },
    computed: {
      confirmButtonType() {
        if (this.disableLogin) {
          return 'info';
        }
        return 'primary';
      },
      isDisableButton() {
        return {'disabled-button': this.disableLogin};
      },
      confirmBtnText() {
        if (this.disableLogin) {
          return `倒计时  ${this.countDown}`;
        }
        return '提交';
      },
      ...mapState({
        guestForm: state => state.guestForm,
        loginForm: state => state.loginForm,
      })
    },
    methods: {
      setCannotLogin() {
        this.countDown = 30;
        const interval = setInterval(() => {
          if (this.countDown === 0) {
            this.disableLogin = false;
            clearInterval(interval);
          }
          this.countDown--;
        }, 1000);
      },
      async contactUs() {
        const valid = await this.validateGuestForm();
        if (valid) {
          const resp = await contactUs(this.guestForm);
          if (resp) {
            this.$alert('我们已收到您的申请，很快将会联系您，敬请期待。', '成功', {
              type: 'success', center: true, confirmButtonText: "确定", confirmButtonClass: 'primary-button middle-button',
            });
          }
        }
      },
      async login() {
        try {
          const resp = await login(this.loginForm);
          if (resp) {
            this.$alert('登录成功', '成功', {
              type: 'success', center: true, confirmButtonText: "确定", confirmButtonClass: 'primary-button middle-button',
              callback: (confirm) => {
                if (confirm === 'confirm') {
                  this.$router.push({name: 'Home'});
                }
              }
            });
          } else {
            this.setLoginError(true);
          }
        } catch (e) {
          this.setLoginError(true);
        }
      },
      confirmBtnClick() {
        this.confirmBtnClickNum++;
        if (this.confirmBtnClickNum > 5) { // 点击次数限制
          this.disableLogin = true;
          this.confirmBtnClickNum = 0;
        } else {
          this.confirm();
        }
      },
      goHome() {
        this.$router.push('/');
      },
      ...mapActions({
        validateGuestForm: 'validateGuestForm',
      }),
      ...mapMutations({
        handleLogin: 'login',
        setLoginError: 'setLoginError',
      }),
    },
    created() {
    },
  };
</script>

<style scoped lang="stylus">
  @import "../../assets/css/main.styl"
  @import "../index.styl"
  .login-body {
    background-image url("../../assets/images/background2.png")
    /*background-color login-background*/
    background-repeat no-repeat
    background-position center
    background-size 100%
    /*height 100%*/
    height: 100vh;
    display: flex;
    align-items: center;
    min-height 933px
    &::before, &::after {
      content ""
      display table
    }
  }
  .login {
    padding 60px 90px
    width 612px - 90px * 2
    min-width 470px
    /*position absolute*/
    /*top 124px*/
    /*bottom 124px*/
    //left calc(50% - (612px / 2))
    margin 30px auto 80px
    /*height 750px*/
    height fit-content
    /*margin-top 30px*/
    /*margin-bottom 80px*/
    @media screen and (min-height 977px) {
      margin calc((100vh - 850px) / 2) auto
    }
    padding-bottom 40px
    background-color white
    border-radius small-max-radius
    display flex
    flex-direction column
    align-items center
    
    & > form {
      flex-grow 1
      width 100%
    }
    .confirmBtn {
      margin-top 20px
    }
  }
  
  .system-name {
    color font-gray
    font-size 1rem
  }
  
  .logo {
    border 0
    cursor pointer
  }

  .footer {
    position absolute
    bottom 0
    width 310px
    left calc(50vw - (310px / 2))
    text-align center
  }
  @media (max-width screenWidth) {
    .login-body {
      height auto
      VStack()
      .login {
        width 100vw
        min-width 0
        padding 10px 20px
        margin 0
        box-sizing border-box
      }
    }
    .footer {
      position static
      margin 10px auto
    }
  }
</style>
